import { ReactNode, createContext, useState } from "react";
import useToast from "../hooks/useToast";
import { ToastContextType } from "./ToastProvider";
import Cookies from "js-cookie";
import { isTokenExpired } from "../../utils/isTokenExpired";

const TenantProviderContext = createContext({});

export const TenantProvider = ({ children }: { children: ReactNode }) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { toast, setToast }: ToastContextType = useToast();
  const [tenantInactive, setTenantInactive] = useState(false);
  const [subscriptionEndDate, setSubscriptionEndDate] = useState<string>("");
  const [refreshTheSubscription, setRefreshTheSubscription] = useState<boolean>(true);
  const expires = Cookies.get("expires-jj-rental-ui");

  const handleTenantError = (error: any | null) => {
    if (tenantId === "" || isTokenExpired(expires)) {
      return null;
    }

    if (error === null) {
      setTenantInactive(false);
      return;
    }

    const message =
      error?.response?.data?.message ||
      error?.message ||
      error?.toString();

    const lowerMsg = message?.toLowerCase() || "";

    if (
      lowerMsg.includes("tenant is inactive")
    ) {
      console.log(`
        ================= TENANT STATUS =================
        Tenant Status : InActive
        Error Message : ${message}
        Timestamp     : ${new Date().toISOString()}
        =================================================
      `);
      setTenantInactive(true);
      return;
    }

    setTenantInactive(false);
    console.log(`
      ================= TENANT STATUS =================
      Tenant Status : Active
      Error Message : ${error?.response?.data}
      Timestamp     : ${new Date().toISOString()}
      =================================================
    `);

    const is400Error = error?.response?.status === 400;

    if (!toast?.show && !is400Error) {
      setToast({
        show: true,
        title: "Oops! Something went wrong. Please refresh the page."
      });
    }
  }

  const value = { tenantInactive, handleTenantError, subscriptionEndDate, setSubscriptionEndDate, refreshTheSubscription, setRefreshTheSubscription };

  return (
    <TenantProviderContext.Provider value={value}>
      {children}
    </TenantProviderContext.Provider>
  );
};

export default TenantProviderContext;